import { useEffect, useState } from "react";
import { PHONE_CONTACT_NUMBER_DEFAULT, PHONE_CONTACT_NUMBER_NEW_CARS, PHONE_CONTACT_NUMBER_USED_CARS, WHATSAPP_CONTACT_NUMBER } from "@globalConfig";
var normalizeNumberForDisplay = function normalizeNumberForDisplay(num) {
  return num === null || num === void 0 ? void 0 : num.replace("+966", "");
};
function useContactNumbers() {
  var carCondition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var whatsappCallNumber = WHATSAPP_CONTACT_NUMBER.substring(1);
  var whatsappDisplayNumber = normalizeNumberForDisplay(WHATSAPP_CONTACT_NUMBER);

  // Call center numbers
  var _useState = useState(PHONE_CONTACT_NUMBER_DEFAULT),
    callCenterCallNumber = _useState[0],
    setCallCenterCallNumber = _useState[1];
  var _useState2 = useState(normalizeNumberForDisplay(PHONE_CONTACT_NUMBER_DEFAULT)),
    callCenterDisplayNumber = _useState2[0],
    setCallCenterDisplayNumber = _useState2[1];
  var setDefaultCallCenterNumber = function setDefaultCallCenterNumber() {
    setCallCenterCallNumber(PHONE_CONTACT_NUMBER_DEFAULT);
    setCallCenterDisplayNumber(normalizeNumberForDisplay(PHONE_CONTACT_NUMBER_DEFAULT));
  };
  useEffect(function () {
    if (carCondition === "new") {
      setCallCenterCallNumber(PHONE_CONTACT_NUMBER_NEW_CARS);
      setCallCenterDisplayNumber(normalizeNumberForDisplay(PHONE_CONTACT_NUMBER_NEW_CARS));
    } else if (carCondition === "used") {
      setCallCenterCallNumber(PHONE_CONTACT_NUMBER_USED_CARS);
      setCallCenterDisplayNumber(normalizeNumberForDisplay(PHONE_CONTACT_NUMBER_USED_CARS));
    } else {
      setDefaultCallCenterNumber();
    }
    return function () {
      setDefaultCallCenterNumber();
    };
  }, [carCondition]);
  return {
    whatsappCallNumber: whatsappCallNumber,
    whatsappDisplayNumber: whatsappDisplayNumber,
    callCenterCallNumber: callCenterCallNumber,
    callCenterDisplayNumber: callCenterDisplayNumber
  };
}
export default useContactNumbers;